<template>
  <div>
      <div id="bind_card">
        <p style="" class="bind_title">
          <span>完善信息</span>
          <label @click="$emit('close')">关闭</label>
        </p>
        <p class="bind_title_tip">请绑定投保人本人的银行卡</p>
        <div class="pn-field-mod noborder">
          <div class="bd">
            <div class="pn-field-list">
              <dl>
                <dt>真实姓名</dt>
                <dd>
                  <input type="text" class="i-text" name="trueName" v-model="trueName" placeholder="填写姓名">
                </dd>
              </dl>
              <dl>
                <dt>银行卡号</dt>
                <dd>
                  <input type="tel" class="i-text" name="bank_no" v-model="bank_no" placeholder="填写银行卡号">
                </dd>
              </dl>
              <dl>
                <dt>开户银行</dt>
                <dd>
                  <div class="i-bank">
                    <select name="openBank" :class="{'selectChange':isSelectChange}" autocomplete="off" v-model="openBank" @change='selectOpenBank'>
                        <option v-for="(item,i) in bankInfo" :key="i" :code="item.bankCode" :isNeedSign="item.isNeedSign">
                            {{item.bankName}}
                        </option>
                    </select>
                  </div>
                </dd>
              </dl>
              <dl>
                <dt>所属地区</dt>
                <dd>
                    <input type="text" class="i-text" readonly="readonly" @click="showCascadePicker" placeholder="选择开户银行所在地区" :value="provicecity">
                </dd>
              </dl>
              <dl>
                <dt>银行预留手机</dt>
                <dd>
                  <a href="javascript:;" class="reserved_phone" @click="showPhoneExplan()">i</a>
                  <input type="tel" class="i-text" v-model="phoneNo" placeholder="填写银行预留手机" maxlength="11">
                </dd>
              </dl>
              <dl>
                <dt>短信验证</dt>
                <dd class="td_r_pho">
                  <a v-if="!isIFalse" href="javascript:;" class="bank_code" :class="{'bank_code':true,'i-false':isIFalse}" @click="getSmsCode">获取验证码</a>
                   <a v-else href="javascript:;" class="bank_code" :class="{'bank_code':true,'i-false':isIFalse}">{{countSet}}</a>
                  <input type="text" class="i-text float_r_pho" name="s_code" v-model="s_code" maxlength="6" placeholder="输入短信验证码">
                </dd>
              </dl>         
            </div>
          </div>
        </div>
        <div class="bindcard_tips" v-show="readFlag">
          <i class="pa_checkbox" @click="iReaded()" :class="{'checked':isChecked}"></i>
          <p class="tips_cont">我已阅读并同意
            <a class="payPro" @click.stop="tiaokaunshgow(0)"  v-show="payProShowFlag">《银行卡快捷支付服务协议》<span>和</span></a><a class="xbPro" @click.stop="tiaokaunshgow(1)" >《重新投保缴费转账扣款客户须知》</a>
          </p>
        </div>
        <a href="javascript:;" class="i-save" @click="bindCardSure()">立即绑定</a>
      </div>
      <div class="ifram_page_view_bg" v-show="iframeShowFlag">
        <div class="ifram_page_view">
          <div class="ifram_w">
            <iframe :src="tiaokuanurl" frameborder="0" scrolling="yes"></iframe>
          </div>
          <img src="../assets/images/close_btn.png" class="bank_pageview_close" alt="" @click="iframeShowFlag=false">
        </div>
      </div>
      <div class="dailog-rule dailog-rule-cardphone" v-show="phoneExplan">
        <div class="inner">
          <h3>银行预留手机号</h3>
          <div class="inner-2">
            <p>银行预留手机号是您在办理银行卡时使用的手机号码。如预留手机号已遗忘或失效，您可联系银行客服处理。</p>
          </div>
          <div class="bottom-btn">
            <a href="javascript:void(0);" class="desc-ok" @click="phoneExplan=false">我知道了</a>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src
// 根api地址，通过环境变量的配置获取
const API_PATH = process.env.VUE_APP_API_URL;
// 业务api地址
const API_QUERY_REGION_INFO = `${API_PATH}/mapi/insurance/insuranceRenew/baseAPI/queryBankAndRegionInfo.json`;
const API_SEND_CODE = `${API_PATH}/mapi/insurance/insuranceRenew/baseAPI/autoRenewalSendCodeForH5.json`;
const API_UPDATE_BIND_CARD = `${API_PATH}/mapi/insurance/insuranceRenew/publicAPI/updateAutoRenewalAccount.json`;

import base from '../mixins/base';
export default {
  name: 'BindCard',
  mixins: [base],
  data() {
    return {
      name: '添加银行卡',
      isChecked:false,
      isSelectChange:false,
      readFlag:false,
      phoneExplan:false,
      payProShowFlag:false,
      iframeShowFlag:false,
      payAccountServerUrl:'',
      renewalNoticeAPPUrl:'',
      tiaokuanurl:'',
      userid:'',
      idCard:'',
      trueName:'',//真实姓名
      bank_no:'',//银行卡号
      openBank:'选择开户银行',
      openBankCode:'',
      proviceCode:'',//省
      provinceName:'',
      cityCode:'',//市
      cityName:'',
      phoneNo:'',//银行预留手机
      provicecity:'',//省市text
      isNeedSign:'',
      s_code:'',
      bankInfo:[],
      city:[],
      cascadeData : [],
      sendCodeDate:{channelSeqNo:'',signFlag:'',traceNo:''},
      validateTrue:false,
      isIFalse:false,
      countSet:60,
      onGetCode: false
    }
  },
  props: {
    realName: {
      type: String,
      default: ''
    },
    phone: {
      type: String,
      default: ''
    },
    userId: { 
      type: String,
      default: ''
    },
    idCardNo: {
      type: String,
      default: ''
    }
  },
  components:{
  },
  computed: {
    
  },
  mounted () {
    this.trueName = this.realName;
    this.phoneNo = this.phone;
    this.userid = this.userId;
    this.idCard = this.idCardNo;
  },
  methods: {
    showCascadePicker() {
      this.cascadePicker.show();
    },
    selectHandle(selectedVal, selectedIndex, selectedText) {
      let self = this;
      self.provicecity = selectedText[0]+" "+selectedText[1];
      self.proviceCode = selectedVal[0];
      self.cityCode = selectedVal[1];
      self.provinceName = selectedText[0];
      self.cityName = selectedText[1];
    },
    cancelHandle() {
      
    },
    showPhoneExplan(){
        let self = this;
        self.phoneExplan =  true;
    },
    async queryBankAndRegionInfo() {
      let self = this;
      //查询省市银行信息
      const response = await axios.post(API_QUERY_REGION_INFO, {});
      let result = response.data;
      if(response.code !=1){
          self.showToast(response.msg);
          return;
      }
      //条款数据
      self.payAccountServerUrl = result.payAccountServerUrl;
      self.renewalNoticeAPPUrl = result.renewalNoticeAPPUrl;
      //银行数据
      self.bankInfo = result.bankInfo;
      let default_option = {bankCode: "0",bankName: "选择开户银行",isNeedSign: ""};
      self.bankInfo.unshift(default_option);
      //省市数据
      let json = JSON.parse(JSON.stringify(result.regionInfo).replace(/provinceCode/g,"value"))
      json =JSON.parse(JSON.stringify(json).replace(/provinceName/g,"text"))
      json =JSON.parse(JSON.stringify(json).replace(/cityCode/g,"value"))
      json = JSON.parse(JSON.stringify(json).replace(/cityName/g,"text"))
      json = JSON.parse(JSON.stringify(json).replace(/cityInfo/g,"children"))
      self.cascadeData = json;
      //初始化省市组件
      self.cascadePicker = self.$createCascadePicker({
        title: '选择开户银行所在地区',
        data: self.cascadeData,
        selectedIndex: [0, 0],
        onSelect: self.selectHandle,
        onCancel: self.cancelHandle,
        // alias:{ value: 'provinceCode', text: 'provinceName'}
      })

    },
    selectOpenBank(e){
      let self=this;
      let cur=self.bankInfo[e.target.selectedIndex];
      self.payProShowFlag = cur.isNeedSign=='Y' ? true : false;
      self.isNeedSign = cur.isNeedSign;
      self.openBankCode = cur.bankCode;
      if (cur.bankCode !=0) {
        self.isSelectChange = true;
        self.readFlag = true;
      }else{
        self.isSelectChange = false;
        self.readFlag = false;
      }
    },
    checkInputVal(){
      let self = this;
       if(!self.trueName){
          self.showToast('请输入真实姓名');
          self.validateTrue = false;
          return;
      }
      if(!self.bank_no){
          self.showToast('请输入银行卡号');
          self.validateTrue = false;
          return;
      }
      if(self.openBankCode=="0"){
          self.showToast('请选择开户银行');
          self.validateTrue = false;
          return;
      }
      if(!self.proviceCode || !self.cityCode){
          self.showToast('请选择开户银行所在地区');
          self.validateTrue = false;
          return;
      }
      if(!self.phoneNo){
          self.showToast('请输入手机号');
          self.validateTrue = false;
          return;
      }else{
        if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(self.phoneNo))){ 
          self.showToast('手机号输入有误');
          self.validateTrue = false;
          return;
         }
      }
      self.validateTrue = true;
    },
    getSmsCode(){
      let self = this;
      self.checkInputVal();
      if(!self.validateTrue){
          return;
      }
      if(self.isIFalse){
          return;
      }
      self.autoRenewalSendCode();
    },
    countDown(callback){
        let self = this;
        let clock = window.setInterval(() => {
          self.countSet--
          if(self.countSet <= 0){
            self.isIFalse=false;
            self.countSet=60;
            window.clearInterval(clock);
          }else{
            self.isIFalse=true;
          }
        },1000)
    },
    autoRenewalSendCode(){
      let self = this;
       if (self.onGetCode) {
        return;
      }
      self.checkInputVal();
      if(!self.validateTrue){
          return;
      }
      self.onGetCode = true;
      //发送验证码
      self.showLoading();
      var params={
        "userId":self.userid,
        "idCard":self.idCard,
        "phone":self.phoneNo,
        "clientId":'',
        "userName":self.trueName,
        "bankAccountNo":self.bank_no,
        "bankAccountType":'',
        "bankCode":self.openBankCode,
        "provinceCode":self.proviceCode,
        "cityCode":self.cityCode,
        "isNeedSign":self.isNeedSign,
        "isNeedEncrypt":"1",//为空表示需要加密
        "subBranchCode":'' // 分行编码
      }
     
      axios.post(API_SEND_CODE, params).then((response) => {
        self.hideLoading();
        self.onGetCode = false;
        if (response.code === 1) {
          self.sendCodeDate = response.data;
          self.isIFalse=true;
          self.countDown(function(){
              self.isIFalse=false;
          });
        } else {
          self.showToast(response.msg)
        }
      }).catch((error) => {
        self.onGetCode = false;
        self.showToast('网络异常！');
      });
    },
    bindCardSure(){
      let self = this;
      self.checkInputVal();
      if(!self.validateTrue){
          return;
      }
      if(!self.sendCodeDate.signFlag){
         self.showToast('请获取验证码');
        return;
      }
      if(!self.s_code){
         self.showToast('请输入短信验证码');
        return;
      }
      if(!self.isChecked){
         self.showToast('请阅读并同意协议');
        return;
      }
      self.showLoading();
      var data={
        "userId":self.userid,
        "idCard":self.idCard,
        "userName":self.trueName,
        "isHistoryAccount":2,//?
        "autoRenewSourceCode":7,//7-h5外头前置绑卡
        "colMode":5,//账户类型银行卡
        "phone":self.phoneNo,                                                         
        "code":self.s_code, //验证码
        "bankAccountNo":self.bank_no,
        "bankCode":self.openBankCode, //银行大类编码；
        "bankName":self.openBank, //银行大类名称；
        "provinceCode":self.proviceCode,
        "provinceName":self.provinceName,
        "cityCode":self.cityCode,
        "cityName":self.cityName,
        "signFlag":self.sendCodeDate.signFlag, //签约标识 1-未签约 2-已签约 或无需签约
        "channelSeqNo":self.sendCodeDate.channelSeqNo, //流水号，短信接口返回；
        "traceNo":self.sendCodeDate.traceNo// 令牌号； 短信发送接口返回；
      };
      axios.post(API_UPDATE_BIND_CARD, data).then((response) => {
        self.hideLoading();
        if (response.code === 1) {
          self.$store.commit('bankCardNo', response.data.unsensitiveAccountNo);
          self.$store.commit('bankBindId', response.data.bindId);
          this.$emit('bindCardSuccess');
        } else {
          this.showToast(response.msg)
        }
      }).catch((error) => {
         self.showToast('网络异常！');
      })
    },
    // 阅读绑定银行卡条款
    tiaokaunshgow(item){
      let self = this;
      if(item && item==1){
        self.tiaokuanurl=self.renewalNoticeAPPUrl;
      }else{
        self.tiaokuanurl=self.payAccountServerUrl;
      }
      self.iframeShowFlag = true;
    },
    iReaded(){
      let self = this;
      self.isChecked = !self.isChecked;
    }
  },
  created() {
    this.queryBankAndRegionInfo();
  }
}
</script>
<style lang="stylus">
  .cube-picker-wheel-wrapper
    div:nth-child(2)
        flex: 2
        -webkit-box-flex: 2
        -webkit-flex: 2
</style>
<style scoped lang="stylus">
    #bind_card
        padding: .4rem .3rem .4rem
        font-size: 0.30rem
        color: #333333
        font-family: PingFangSC-Regular,PingFang SC
        font-weight: 400
      .bind_title
          font-size: .36rem
          font-weight: 500
          display: flex
          justify-content: space-between
          label
            color: #f60
            font-size: .32rem
      .bind_title_tip 
          color: #999999
          font-size: .26rem
          margin: .1rem 0 .4rem
      dl 
          position: relative
          height: 1.1rem
          line-height: 1.1rem
          padding-right: 15px
          border-bottom: 1px solid #f5f5f5
        dt 
            position: absolute
            height: 1.1rem
            left: 0px
            top: 0
            color: #333333
        dd 
            text-align: left
            padding-left: 2.2rem
            overflow: hidden
            white-space: nowrap
            text-overflow: ellipsis
            .i-text 
                width:100%
                height: 1rem
                line-height: 1rem
                color: #333333
                font-size: .3rem
                text-align: left
                -webkit-appearance: none
                -moz-appearance: none
                appearance: none
                border: 0
            select 
                width: calc(100% - 2.2rem)
                height: 1rem
                font-size: .3rem
                text-align: left
                direction: ltr
                outline: none
                color: #ccc
                position: absolute
                right: 0
                border: none
                background:transparent
                -webkit-appearance: none
            .selectChange
                color:#333
            .reserved_phone 
                display: inline-block;
                height: .32rem
                border-radius: .32rem
                border: 1px solid #5A5A5A
                color: #5A5A5A
                line-height: .3rem
                text-align: center
                margin-top: .4rem
                width: .32rem
                position: absolute
                right: 0
                font-size: 0.2rem
            .bank_code 
                display: inline-block
                height: .6rem
                border-radius: .3rem
                border: 1px solid #FF6600
                color: #FF6600
                line-height: 0.56rem
                text-align: center
                /*padding: 0 .22rem*/
                margin-top: .25rem
                width: 1.75rem
                position: absolute
                right: 0
                font-size: .26rem
            .i-false
              color: #fff
              background: #ccc
              border: 1px solid #ccc

      .bindcard_tips
                color: #999
                padding: .3rem 0
                font-size: .26rem
                a 
                    color: #508CEE
                    display: inline
                .tips_cont 
                    margin-left: .44rem
                .pa_checkbox 
                    float: left
                    width: .34rem
                    height: .34rem
                    border: 1px solid #e4e4e4
                    border-radius: .2rem
                    display:bloack
                .checked
                    background: url(../assets/images/choosen.png)
                    background-size: cover
                    border: none
      .i-save 
          width: 6.9rem
          border-radius: .44rem
          /*left: 5%*/
          bottom: .2rem
          background: linear-gradient(90deg,rgba(240,77,22,1) 0%,rgba(254,146,25,1) 100%)
          display: block
          margin: 0 auto
          margin-top: 1.06rem
          margin-bottom: .3rem
          position: inherit
          height: .88rem
          line-height: .88rem
          font-size: .3rem
          color: #fff
          text-align: center
      
              
    input::-webkit-input-placeholder 
        color: #ccc


    .ifram_page_view_bg
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(0,0,0,.7);
      z-index: 10;
      .ifram_page_view 
        width: 90%;
        height: 80%;
        margin: 10% auto 0;
        position: relative;
        .ifram_w 
          width: 100%;
          height: 100%;
          overflow-y: scroll;
          -webkit-overflow-scrolling: touch;
        iframe 
          width: 100%;
          height: 100%;
          border-radius: 5px;
        .bank_pageview_close 
          width: 25px;
          height: 25px;
          position: absolute;
          bottom: -35px;
          left: 50%;
          margin-left: -12px;

  .dailog-rule-cardphone 
    position: fixed
    top: 0
    left: 0
    width: 100%
    height: 100%
    background: rgba(0,0,0,0.3)
    z-index: 100
    .inner 
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        padding: 15px;
        color: #666;
        width: 6.3rem
        border-radius: 5px
        height: 4.04rem
        padding: .4rem .3rem
        background: #fff
        h3 
          color: #333333
          font-weight:500
          /*width: 3.2*/
          height: .7rem
          margin: 0 auto
          text-align: center
          line-height: .7rem
          font-size:.32rem
    .inner-2 
        font-size:.28rem
        color: #333
        height: auto
        margin: .1rem 0 .42rem
        overflow: hidden
        overflow-y: scroll
        -webkit-overflow-scrolling: touch
   .desc-ok 
        width: 3rem
        height: .7rem
        border-radius: .7rem
        text-align: center
        line-height: .7rem
        cursor: pointer
        color: #f60
        margin: 0 auto
        display: block
        border: 1px solid #f60
        cursor: pointer
        font-size:.28rem

    
</style>
